(function () {
  // The theme's gallery scrolls the window up to the new photo when the colour
  // changes. A colour chosen in the story should leave the reader where they are.
  // It also puts focus back on the option it re-rendered, and focus scrolls.
  var hold = 0, holdY = 0, orig = window.scrollTo.bind(window);
  if (!window.__afsScroll) {
    window.__afsScroll = true;
    window.scrollTo = function () { if (Date.now() < hold) return; return orig.apply(window, arguments); };
    var focus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (o) { return focus.call(this, Date.now() < hold ? { preventScroll: true } : o); };
  }
  function keepPlace() {
    hold = Date.now() + 3000; holdY = window.scrollY;
    [400, 1000, 2000].forEach(function (t) { setTimeout(function () { if (Math.abs(window.scrollY - holdY) > 40) orig(0, holdY); }, t); });
  }
  document.querySelectorAll('[data-afs]').forEach(function (root) {
  var variants = JSON.parse(root.querySelector('[data-afs-variants]').textContent);
  var byOpt = {}; variants.forEach(function (v) { byOpt[v.o] = v; });
  var current = byOpt[root.dataset.cur] || variants[0];
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };

  function mainRadio(val) {
    var r = null;
    document.querySelectorAll('variant-selects input[type=radio]').forEach(function (i) { if (i.value === val) r = i; });
    return r;
  }

  function paint(v) {
    current = v;
    $$('[data-afs-price]').forEach(function (el) { el.textContent = v.p; });
    $$('[data-afs-colour]').forEach(function (el) { el.textContent = v.o; });
    var img = root.querySelector('[data-afs-img]'); if (img && v.img) img.src = v.img;
    $$('.afs__opt').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.v === v.o ? 'true' : 'false'); });
    $$('.afs__hot.is-on').forEach(function (h) { h.classList.toggle('is-picked', h.dataset.v === v.o); var em = h.querySelector('em'); if (em) em.textContent = h.dataset.v === v.o ? 'Chosen' : (byOpt[h.dataset.v] && !byOpt[h.dataset.v].a ? 'Sold out' : 'Choose this colour'); });
    $$('.afs__tile.is-on').forEach(function (t) { var on = t.dataset.v === v.o; t.classList.toggle('is-picked', on); var em = t.querySelector('em'); if (em) em.textContent = on ? 'Chosen' : (byOpt[t.dataset.v] && !byOpt[t.dataset.v].a ? 'Sold out' : 'Choose'); });
    $$('.afs__chip').forEach(function (c) { var on = c.dataset.v === v.o; c.classList.toggle('is-picked', on); c.querySelector('span').textContent = on ? 'Chosen' : 'Choose'; });
    var sel = root.querySelector('[data-afs-select]'); if (sel) sel.value = v.o;
    $$('[data-afs-add]').forEach(function (b) { b.disabled = !v.a; b.textContent = v.a ? 'Add to bag' : 'Sold out'; });
  }

  function choose(val, from) {
    var v = byOpt[val]; if (!v) return;
    var r = mainRadio(val);
    if (r && !r.checked) { keepPlace(); r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    paint(v);
    if (from && from.classList.contains('afs__hot')) {
      from.classList.add('is-flash'); setTimeout(function () { from.classList.remove('is-flash'); }, 1400);
    }
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('.afs__hot.is-on, .afs__tile.is-on, .afs__chip, .afs__opt');
    if (t) { e.preventDefault(); choose(t.dataset.v, t); return; }
    var off = e.target.closest('.afs__hot.is-off, .afs__tile.is-off');
    if (off) { e.preventDefault(); openAsk(off); return; }
    var fig = e.target.closest('.afs__fig[data-lb]');
    if (fig) openViewer(fig);
  });
  root.addEventListener('keydown', function (e) {
    var fig = e.target.closest && e.target.closest('.afs__fig[data-lb]');
    if (fig && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openViewer(fig); }
  });
  var sel = root.querySelector('[data-afs-select]');
  if (sel) sel.addEventListener('change', function () { choose(sel.value); });

  // Keep in step when the main picker changes.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects') && byOpt[e.target.value]) paint(byOpt[e.target.value]);
  });

  // Add to bag: same cart as the main form, then on to the bag.
  $$('[data-afs-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var msg = root.querySelector('[data-afs-msg]');
      b.disabled = true; b.textContent = 'Adding';
      fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add this colour.');
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (err) { if (msg) msg.textContent = err.message; b.disabled = false; b.textContent = 'Add to bag'; });
    });
  });

  // Chapter links follow the scroll.
  var links = $$('[data-afs-link]');
  var chs = $$('[data-afs-ch]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = en.target.dataset.afsCh;
        links.forEach(function (a) {
          var on = a.dataset.afsLink === id; a.setAttribute('aria-current', on ? 'true' : 'false');
          if (on && a.parentElement.classList.contains('afs__row')) a.parentElement.scrollTo({ left: a.offsetLeft - 16, behavior: 'smooth' });
        });
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    chs.forEach(function (c) { io.observe(c); });

    // Phone bar: up once the main button has scrolled away, down near the end of the page.
    var bar = root.querySelector('[data-afs-bar]');
    var mainBtn = document.querySelector('product-form [type=submit]');
    if (bar && mainBtn) {
      var past = false, inStory = false;
      var upd = function () { var up = past && inStory; bar.classList.toggle('is-up', up); bar.inert = !up; };
      new IntersectionObserver(function (es) { es.forEach(function (en) { past = !en.isIntersecting && en.boundingClientRect.top < 0; upd(); }); }).observe(mainBtn);
      new IntersectionObserver(function (es) { es.forEach(function (en) { inStory = en.isIntersecting; upd(); }); }, { rootMargin: '0px 0px -40% 0px' }).observe(root.querySelector('.afs__main'));
    }
  }

  // Notify me: an email form for a colour or piece that is not in this release.
  // It is the store's own customer form (same list, same welcome email);
  // the tags say what was asked for.
  var ask = root.querySelector('.afs__ask'), main = root.querySelector('.afs__main'), askFor = null;
  if (ask && main) main.appendChild(ask);
  function slug(t) { return String(t).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function openAsk(hot) {
    if (!ask || !main) return;
    if (askFor) askFor.classList.remove('is-asked');
    askFor = hot; hot.classList.add('is-asked');
    var name = hot.dataset.n || '';
    ask.classList.remove('is-done');
    ask.querySelector('[data-afs-ask-name]').textContent = name;
    ask.querySelector('[data-afs-ask-p]').textContent = (hot.dataset.kind === 'colour' ? 'This colour' : 'This piece') +
      ' is not in this release. Leave your email and we will write to you when it is released. You also get $15 off your order of $150 or more.';
    ask.querySelector('[data-afs-ask-msg]').textContent = '';
    var btn = ask.querySelector('[type=submit]'); if (btn) btn.disabled = false;
    var tags = ask.querySelector('[data-afs-tags]');
    tags.value = 'newsletter, waitlist, waitlist-' + tags.dataset.handle + '-' + slug(name);
    ask.classList.add('is-open');
    var m = main.getBoundingClientRect(), h = hot.getBoundingClientRect(), w = ask.offsetWidth;
    var left = Math.max(0, Math.min(h.left - m.left + h.width / 2 - w / 2, m.width - w));
    ask.style.left = left + 'px';
    ask.style.top = (h.bottom - m.top + 8) + 'px';
    var input = ask.querySelector('input[type=email]');
    if (input) input.focus({ preventScroll: true });
    var a = ask.getBoundingClientRect(), room = window.innerHeight - 96;
    if (a.bottom > room) window.scrollBy({ top: a.bottom - room, behavior: 'smooth' });
  }
  function closeAsk() {
    if (!ask || !ask.classList.contains('is-open')) return;
    ask.classList.remove('is-open');
    if (askFor) { askFor.classList.remove('is-asked'); askFor.focus({ preventScroll: true }); askFor = null; }
  }
  if (ask) {
    ask.querySelector('[data-afs-ask-close]').addEventListener('click', closeAsk);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAsk(); });
    document.addEventListener('click', function (e) {
      if (ask.classList.contains('is-open') && !ask.contains(e.target) && !e.target.closest('.afs__hot.is-off, .afs__tile.is-off')) closeAsk();
    });
    // Phones change the window height when the keyboard opens or the address bar
    // hides, and both happen as soon as the form takes focus. Closing on those
    // shut the form a moment after it opened. Only a change of width (turning
    // the phone, resizing a desktop window) moves the tiles, so only that closes it.
    var askW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === askW) return;
      askW = window.innerWidth;
      if (askFor) closeAsk();
    });
    ask.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = ask.querySelector('[data-afs-ask-msg]'), input = ask.querySelector('input[type=email]'), btn = ask.querySelector('[type=submit]');
      var name = askFor ? askFor.dataset.n : '';
      if (!input.value || !input.checkValidity()) { msg.textContent = 'Please enter an email address.'; input.focus({ preventScroll: true }); return; }
      btn.disabled = true; msg.textContent = 'Sending';
      var fail = function (text) { msg.textContent = text || 'That did not go through. Check the address and try again.'; btn.disabled = false; };
      fetch(ask.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(ask), credentials: 'same-origin' })
        .then(function (r) {
          var u = r.url || '';
          // The store's bot check: let the browser post the form and show it.
          if (u.indexOf('/challenge') > -1) { ask.submit(); return; }
          return r.text().then(function (t) {
            var doc = new DOMParser().parseFromString(t, 'text/html');
            var err = doc.querySelector('#' + ask.id + ' [data-afs-ask-err]');
            if (u.indexOf('customer_posted=true') > -1 && !err) {
              ask.classList.add('is-done');
              msg.textContent = 'Thank you. Confirm your address from the email we just sent, and your $15 off $150+ code is waiting there. We will write when ' + name + ' is released.';
            } else if (err && /taken|already/i.test(err.textContent)) {
              ask.classList.add('is-done');
              msg.textContent = 'You are already on our list. We will write when ' + name + ' is released.';
            } else {
              fail(err ? err.textContent.trim() : '');
            }
          });
        })
        .catch(function () { fail(); });
    });
  }

  // Viewer
  var lb = root.querySelector('[data-afs-lb]'), lbImg = root.querySelector('[data-afs-lbimg]'), cnt = root.querySelector('[data-afs-count]');
  var pics = $$('.afs__fig[data-lb] img'), at = 0, opener = null;
  function biggest(img) {
    var best = img.currentSrc || img.src, w = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) { var p = c.trim().split(/\s+/); var n = parseInt(p[1], 10); if (p[0] && n > w) { w = n; best = p[0]; } });
    return best;
  }
  function show(i) { at = (i + pics.length) % pics.length; var p = pics[at]; lbImg.src = biggest(p); lbImg.alt = p.alt || ''; cnt.textContent = (at + 1) + ' of ' + pics.length; }
  function openViewer(fig) {
    var img = fig.querySelector('img'); if (!img || !lb || !lb.showModal) return;
    opener = fig; show(pics.indexOf(img)); lb.showModal(); root.querySelector('[data-afs-close]').focus();
  }
  if (lb) {
    root.querySelector('[data-afs-close]').addEventListener('click', function () { lb.close(); });
    root.querySelector('[data-afs-prev]').addEventListener('click', function () { show(at - 1); });
    root.querySelector('[data-afs-next]').addEventListener('click', function () { show(at + 1); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(at + 1); if (e.key === 'ArrowLeft') show(at - 1); });
    lb.addEventListener('close', function () { if (opener) opener.focus(); });
    lb.addEventListener('click', function (e) { if (e.target === root.querySelector('[data-afs-stage]')) lb.close(); });
    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) show(at + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  paint(current);
  });
})();
